// Application configuration
// In production (monorepo): leave VITE_API_URL empty so apiUrl is "" and
// axios uses same-origin relative URLs proxied through nginx /api/.
const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? (import.meta.env.PROD ? '' : 'http://localhost:8000'),
  odooUrl: import.meta.env.VITE_ODOO_URL || '',
};

export default config;
